import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import ButtonSeplag from '../../components/buttonSeplag/ButtonSeplag';

const Footer = ({ setVisible, onConfirm, closeOnConfirm }) => (
    <div>
        <ButtonSeplag
            label="Sim"
            type="button"
            icon="pi pi-check"
            iconPos="left"
            onClick={async () => {
                await onConfirm();
                if (closeOnConfirm) {
                    setVisible(false);
                }
            }}
        />
        <ButtonSeplag
            label="Não"
            type="button"
            icon="pi pi-times"
            iconPos="left"
            onClick={() => setVisible(false)}
            theme="Raised"
        />
    </div>
);

const FooterOk = ({ setVisible, onConfirm, closeOnConfirm }) => (
    <div>
        <Button
            label="OK"
            type="button"
            onClick={async () => {
                if (onConfirm) await onConfirm();

                if (closeOnConfirm) {
                    setVisible(false);
                }
            }}
        />
    </div>
);

function ConfirmDialog({ onShow, onHide, isOk = false, closeOnConfirm = true, ...rest }, ref) {
    const [visible, setVisible] = useState(false);
    const [message, setMessage] = useState('');
    const [onConfirm, setOnConfirm] = useState(() => {});

    const show = (message, confirmCallback) => {
        setVisible(true);
        setMessage(message);
        setOnConfirm(() => confirmCallback);
        if (onShow) setTimeout(() => onShow(), 10);
    };

    const hide = (param) => {
        setVisible(false);
        if (onHide) setTimeout(() => onHide(param), 300);
    };

    useImperativeHandle(
        ref,
        () => {
            return { show, hide };
        },
        []
    );

    return (
        <Dialog
            header="Confirmação"
            visible={visible}
            footer={() =>
                isOk ? (
                    <FooterOk
                        setVisible={setVisible}
                        onConfirm={onConfirm}
                        closeOnConfirm={closeOnConfirm}
                    />
                ) : (
                    <Footer
                        setVisible={setVisible}
                        onConfirm={onConfirm}
                        closeOnConfirm={closeOnConfirm}
                    />
                )
            }
            onHide={() => setVisible(false)}
            {...rest}
        >
            <p>{message}</p>
        </Dialog>
    );
}

export default forwardRef(ConfirmDialog);
